import VueQuillEditor from "vue-quill-editor";
import Vue from "vue";

Vue.use(VueQuillEditor);

import "@core/scss/vue/libs/quill.scss";
